/** @type {import('../help-index.js').HelpSidebarItem} */
export const LAB_REC_SS_DEPOSIT_ITEM = {
  id: 'ss_deposit_sidebar',
  screenId: 'lab-rec-ss-deposit',
  label: 'Últimos aportes',
  description: 'Datos del último depósito de cargas sociales.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Registrás el último depósito de aportes y contribuciones que hizo la empresa (art. 12 DL 17.250). Esos datos se imprimen en todos los recibos de sueldo, en la sección «Último depósito de aportes».',
      },
      {
        title: 'Campos',
        fields: [
          { label: 'Fecha de depósito', description: 'Día en que se realizó el depósito ante la AFIP/banco. Obligatoria.' },
          { label: 'Período cubierto — mes / año', description: 'Mes y año que cubre ese depósito (ej. enero 2026). Obligatorios.' },
          { label: 'Banco', description: 'Entidad bancaria donde se depositó. Lista del catálogo laboral. Obligatoria.' },
        ],
        paragraphs: [
          'Tocá «Guardar» para actualizar. Si no cargás estos datos, el recibo mostrará un aviso para configurarlos acá.',
        ],
      },
    ],
  },
}
